/* tslint:disable */
/* eslint-disable */
export enum AdjustmentReasonEnum {
  TransactionFee = 'TransactionFee',
  DeviceFee = 'DeviceFee',
  MonthlyFee = 'MonthlyFee'
}
